"use strict";

var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  var desc = Object.getOwnPropertyDescriptor(m, k);
  if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
    desc = {
      enumerable: true,
      get: function get() {
        return m[k];
      }
    };
  }
  Object.defineProperty(o, k2, desc);
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});
var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});
var __importStar = this && this.__importStar || function () {
  var _ownKeys = function ownKeys(o) {
    _ownKeys = Object.getOwnPropertyNames || function (o) {
      var ar = [];
      for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
      return ar;
    };
    return _ownKeys(o);
  };
  return function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k = _ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
    __setModuleDefault(result, mod);
    return result;
  };
}();
var __exportStar = this && this.__exportStar || function (m, exports) {
  for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.writeToPath = exports.writeToString = exports.writeToBuffer = exports.writeToStream = exports.write = exports.format = exports.FormatterOptions = exports.CsvFormatterStream = void 0;
var util_1 = require("util");
var stream_1 = require("stream");
var fs = __importStar(require("fs"));
var FormatterOptions_1 = require("./FormatterOptions");
var CsvFormatterStream_1 = require("./CsvFormatterStream");
__exportStar(require("./types"), exports);
var CsvFormatterStream_2 = require("./CsvFormatterStream");
Object.defineProperty(exports, "CsvFormatterStream", {
  enumerable: true,
  get: function get() {
    return CsvFormatterStream_2.CsvFormatterStream;
  }
});
var FormatterOptions_2 = require("./FormatterOptions");
Object.defineProperty(exports, "FormatterOptions", {
  enumerable: true,
  get: function get() {
    return FormatterOptions_2.FormatterOptions;
  }
});
var format = function format(options) {
  return new CsvFormatterStream_1.CsvFormatterStream(new FormatterOptions_1.FormatterOptions(options));
};
exports.format = format;
var write = function write(rows, options) {
  var csvStream = (0, exports.format)(options);
  var promiseWrite = (0, util_1.promisify)(function (row, cb) {
    csvStream.write(row, cb);
  });
  rows.reduce(function (prev, row) {
    return prev.then(function () {
      return promiseWrite(row);
    });
  }, Promise.resolve()).then(function () {
    csvStream.end();
  }).catch(function (err) {
    csvStream.emit('error', err);
  });
  return csvStream;
};
exports.write = write;
var writeToStream = function writeToStream(ws, rows, options) {
  return (0, exports.write)(rows, options).pipe(ws);
};
exports.writeToStream = writeToStream;
var writeToBuffer = function writeToBuffer(rows) {
  var opts = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var buffers = [];
  var ws = new stream_1.Writable({
    write: function write(data, enc, writeCb) {
      buffers.push(data);
      writeCb();
    }
  });
  return new Promise(function (res, rej) {
    ws.on('error', rej).on('finish', function () {
      return res(Buffer.concat(buffers));
    });
    (0, exports.write)(rows, opts).pipe(ws);
  });
};
exports.writeToBuffer = writeToBuffer;
var writeToString = function writeToString(rows, options) {
  return (0, exports.writeToBuffer)(rows, options).then(function (buffer) {
    return buffer.toString();
  });
};
exports.writeToString = writeToString;
var writeToPath = function writeToPath(path, rows, options) {
  var stream = fs.createWriteStream(path, {
    encoding: 'utf8'
  });
  return (0, exports.write)(rows, options).pipe(stream);
};
exports.writeToPath = writeToPath;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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